import request from "@/router/axios";

export const getList = (data) => {
  return request({
    url: "/api/produce/inspection-work-order-audit/select/page",
    method: "post",
    data,
  });
};

export const auditInspectionTask = (row) => {
  return request({
    url: "/api/produce/inspection-work-order-audit/audit",
    method: "post",
    data: row,
  });
};

export const rejectInspectionTask = (row) => {
  return request({
    url: "/api/produce/inspection-work-order-audit/reject",
    method: "post",
    data: row,
  });
};
